import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  ElementRef,
  ChangeDetectionStrategy
} from '@angular/core';
import { WindowContainerContext } from '../window-context';
import { WINDOW_CONTAINER_CONTEXT } from '../tokens';
import { Store } from '@ngrx/store';
import { SetWindowPositiion } from '../window.actions';
import {
  Observable,
  merge
} from 'rxjs';
import {
  getWindowDraggable,
  getWindowWidth,
  getWindowHeight
} from '../window.selectors';
import { CdkDragEnd } from '@angular/cdk/drag-drop';
import { WindowResizerComponent } from '../window-resizer/window-resizer.component';
import { startWith } from 'rxjs/operators';

@Component({
  selector:    'dx-window-container',
  templateUrl: './window-container.component.html',
  styleUrls:   [ './window-container.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WindowContainerComponent<T> implements OnInit {

  @ViewChild('container', { static: true }) public containerRef: ElementRef<any>;
  @ViewChild(WindowResizerComponent, { static: true }) public windowContainerResizer: WindowResizerComponent;

  public context!: WindowContainerContext<T>;

  public draggable$: Observable<boolean>;
  public resizing$: Observable<boolean>;

  public width$: Observable<string>;
  public height$: Observable<string>;

  constructor(
    @Inject(WINDOW_CONTAINER_CONTEXT) context: any,
    public store$: Store<any>,
  ) {
    this.context = context;
  }

  ngOnInit() {

    this.draggable$  = this.store$.select(getWindowDraggable(this.context.id));
    this.resizing$ = this.windowContainerResizer.resizing$.pipe(startWith(false));

    this.width$ = merge(
      this.store$.select(getWindowWidth(this.context.id)),
      this.windowContainerResizer.width$,
    );

    this.height$ = merge(
      this.store$.select(getWindowHeight(this.context.id)),
      this.windowContainerResizer.height$,
    );

  }

  onDragEnded($event: CdkDragEnd<any>) {
    const nativeElement = $event.source.element.nativeElement;
    const pos = nativeElement.getBoundingClientRect();
    $event.source.reset();
    this.store$.dispatch(new SetWindowPositiion(
      this.context.id,
      pos.left + 'px',
      pos.top + 'px'
    ));
  }
}
